import React from "react";
import dayjs from "dayjs";
import { useHistory } from "react-router";
import { ProductImageModal, LUX_Q2_VR_OFFER_LANDSCAPE_IMAGE, SanitizedHtml } from "halifax";
import {
  MODAL_ALERT,
  ModalAlertProperties,
  ModalCategoryType,
  ModalScreens,
  CLICKED_LUXURY_OFFER_PROMOTION_CTA,
  ClickedLuxuryOfferPromotionCtaProperties,
  TravelWalletOffer,
} from "redmond";
import {
  HAS_SEEN_LUX_Q2_VR_OFFER_MODAL_KEY,
  PATH_PREMIUM_STAYS_VR,
  PATH_TERMS_LUX_Q2_VR_OFFER,
} from "@capone/common";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { useQ2VROffer } from "../../../../hooks/useQ2VROffer";
import "./styles.scss";

export interface LuxQ2VROfferModalProps {
  shouldBeVacationRentals: boolean;
  travelWalletOffers: TravelWalletOffer[];
}

export const LuxQ2VROfferModal = ({
  shouldBeVacationRentals,
  travelWalletOffers,
}: LuxQ2VROfferModalProps): JSX.Element | null => {
  const q2VROffer = useQ2VROffer(travelWalletOffers);
  const history = useHistory();

  const hasSeenLuxQ2VROfferModal = localStorage.getItem(
    HAS_SEEN_LUX_Q2_VR_OFFER_MODAL_KEY,
  );

  const [openLuxQ2VROfferModal, setOpenLuxQ2VROfferModal] =
    React.useState(false);

  React.useEffect(() => {
    if (
      !hasSeenLuxQ2VROfferModal &&
      q2VROffer &&
      !shouldBeVacationRentals
    ) {
      setOpenLuxQ2VROfferModal(true);
      const properties: ModalAlertProperties = {
        type: "luxury_q2_vr_offer",
        screen: ModalScreens.PREMIUM_STAYS_LANDING,
        primary_button: "Book now",
        secondary_button: "",
        step: "search",
        funnel: "premier_collection",
        category: ModalCategoryType.FEATURE,
        modal_subtitle: q2VROffer.descriptions[0] || "",
        modal_title: q2VROffer.title,
        agent_title: "",
        agent_subtitle: "",
        lob: "vacation rentals",
      };
      trackEvent({ eventName: MODAL_ALERT, properties });
      localStorage.setItem(HAS_SEEN_LUX_Q2_VR_OFFER_MODAL_KEY, "true");
    }

    return () => {};
  }, [q2VROffer, shouldBeVacationRentals]);

  if (!q2VROffer) {
    return null;
  }

  return (
    <ProductImageModal
      imageUrl={LUX_Q2_VR_OFFER_LANDSCAPE_IMAGE}
      // eslint-disable-next-line react/no-danger
      title={<SanitizedHtml as="span" html={q2VROffer.title} />}
      description={q2VROffer.descriptions[0] || ""}
      buttonText="Book now"
      buttonAction={() => {
        setOpenLuxQ2VROfferModal(false);
        trackEvent({
          eventName: CLICKED_LUXURY_OFFER_PROMOTION_CTA,
          properties: {
            offer_name: "luxury_q2_vr_offer",
            entry_point: "offer_promotion_modal",
          } as ClickedLuxuryOfferPromotionCtaProperties,
        });
        history.push(PATH_PREMIUM_STAYS_VR);
      }}
      termsAndConditionsUrl={PATH_TERMS_LUX_Q2_VR_OFFER}
      termsAndConditionsSuffix={`| Expires on ${dayjs(
        q2VROffer.expiresOn,
      ).format("MMMM D, YYYY")}`}
      openModal={openLuxQ2VROfferModal}
      setOpenModal={setOpenLuxQ2VROfferModal}
      className="lux-q2-vr-offer-modal"
    />
  );
};
